import React from 'react';
import { footer } from './data/footer.json';
import { useTranslation } from "react-i18next";
import { loadOneTrust } from '../../utils/OneTrust';
import { lobRoot } from '../../utils/LobLogicModule';
import Modal from '../Modal/Modal';
import sanitizeHtml from 'sanitize-html';
import './Footer.scss';

/**
 * Footer component
 * Manages the Global Footer to be shown in all the suppages
 */
const Footer = (data) => {

    const { t, i18n } = useTranslation('footer');
    const getYear = () => new Date().getUTCFullYear();

    const FooterLogo = () => {
        let Logo;

        switch(lobRoot) {
            case '/ml':
                Logo = () => (
                    <a id={(footer.boalogo_id ? footer.boalogo_id : 'Footer_Logo')} data-component="Footer" className="external-link-modal t-track-footer_link" data-modal-target={(footer.boalogo_needs_interstitial ? "exit-lang" : "")} href="https://www.ml.com/" target="_blank" rel="noopener noreferrer" data-bactmln="Footer-_-Click_Content-_-logo">
                        <img className="ml-logo-img" src={`${process.env.PUBLIC_URL}/assets/images/merrill_logo.svg`} alt={t(footer.merrilllogo_alt)} />
                    </a>
                );
                break;
            default:
                Logo = () => (
                    <a id={(footer.boalogo_id ? footer.boalogo_id : 'Footer_Logo')} data-component="Footer" className="external-link-modal t-track-footer_link" href={t(footer.boalogo_link)} target="_blank" rel="noopener noreferrer" data-bactmln="Footer-_-Click_Content-_-logo">
                        <img src="/global/assets/images/logo-bac-horiz-1.0.0.svg" alt="Bank of America" />
                    </a>
                );
                break;
        };

        return (
            <>
                { footer.boalogo &&
                    <div className="footer__boalogo">
                        <Logo />
                    </div>
                }
            </>
        );
    };
    
    return (
        <>
        <footer className={"section footer container_wrapper " + (footer.classes ? footer.classes : '')}>
            <div className="section__wrapper footer__wrapper">
                <FooterLogo />
                <div className="footer__bottom">
                    {(lobRoot !=='/ml' && lobRoot !=='/privatebank') ?
                    <ul>
                        <li>
                            <img className="footer__lock" src={`${process.env.PUBLIC_URL}/assets/icons/icon_lock.svg`} alt="lock" />
                            <span className="ada-invisible">{t(footer.lock_label)}</span>
                            &nbsp;|&nbsp;{i18n.language === 'es' ? <Modal url={`https://www.bankofamerica.com/security-center/privacy-overview/`} target='_blank' component="a" className="t-track-body-copy-link"  dataTag={`Footer-_-Hyperlink-_-Privacy`} dataModal={`Exit_Lang`} linkName={(t(footer.privacy_link.label))} contentId="interstitial"/> : <a className="t-track-body-copy-link" id={(footer.privacy_link.id ? footer.privacy_link.id : 'Footer_Privacy')} data-component="Footer" data-modal-target={(footer.boalogo_needs_interstitial ? "exit-lang" : "")} href={"https://www.bankofamerica.com/security-center/privacy-overview/" + (footer.boalogo_needs_interstitial ? "?request_locale=en_US" : "")} target="_blank" rel="noopener noreferrer" dangerouslySetInnerHTML={{ __html: sanitizeHtml(t(footer.privacy_link.label), { interpolation: { escapeValue: false } }) }} data-bactmln="Footer-_-Hyperlink-_-Privacy"></a> }
                        </li>
                        <li>&nbsp;|&nbsp;{i18n.language === 'es' ? <Modal url={`https://www.bankofamerica.com/security-center/overview/`} target='_blank' component="a" className="t-track-body-copy-link"  dataTag={`Footer-_-Hyperlink-_-Security`} dataModal={`Exit_Lang`} linkName={(t(footer.security_link.label))} contentId="interstitial"/> : <a className="t-track-body-copy-link" id={(footer.security_link.id ? footer.security_link.id : 'Footer_Security')} data-component="Footer" target="_blank" rel="noopener noreferrer" data-modal-target={(footer.interstitial_lang ? "exit-lang" : "")} href={"https://www.bankofamerica.com/security-center/overview/" + (footer.interstitial_lang ? "?request_locale=en_US" : "")} dangerouslySetInnerHTML={{ __html: sanitizeHtml(t(footer.security_link.label), { interpolation: { escapeValue: false } }) }} data-bactmln="Footer-_-Hyperlink-_-Security"></a> }</li>
                        <li>&nbsp;|&nbsp;<Modal id="Advertising_Practices" ariaLabel={sanitizeHtml(t(footer.adv_link.label))} component="Footer" className="advertising-practices t-track-custom"  dataTag="Footer-_-Click-_-AdPractices" dataModal={`Advertising_Practices`} linkName={sanitizeHtml(t(footer.adv_link.text))} contentId="advertising-practices"/></li>
                        <li>&nbsp;|&nbsp;<button id="Footer_OneTrust" aria-label={sanitizeHtml(t(footer.cookie_link_label))} className="ot-sdk-show-settings footer__cookie t-track-custom" data-bactmln="Footer-_-Click-_-OneTrust"></button></li>
                    </ul>
                    : 
                    <button id="Footer_OneTrust" className="ot-sdk-show-settings footer__cookie t-track-custom" data-bactmln="Footer-_-Click-_-OneTrust"></button>
                    }
                    {lobRoot !=='/ml' ?
                    <div>
                        Bank of America, N.A. {t(footer.member, { interpolation: { escapeValue: false } })} FDIC. <span className="footer__ehl">
                        {i18n.language === 'es' ? <Modal url={`https://www.bankofamerica.com/help/equalhousing_popup.go`} target='_blank' component="a" className="t-track-body-copy-link"  dataTag={`Footer-_-Hyperlink-_-EHL`} dataModal={`Exit_Lang`} linkName={(t(footer.ehl_link.label))} contentId="interstitial"/> : <a className="t-track-body-copy-link" id={(footer.ehl_link.id ? footer.ehl_link.id : 'Footer_EHL')} data-component="Footer" data-modal-target={(footer.interstitial_lang ? "exit-lang" : "")} href={"https://www.bankofamerica.com/help/equalhousing_popup.go" + (footer.interstitial_lang ? "?request_locale=en_US" : "")} dangerouslySetInnerHTML={{ __html: sanitizeHtml(t(footer.ehl_link.label), { interpolation: { escapeValue: false } }) }} target="_blank" rel="noopener noreferrer" data-bactmln="Footer-_-Hyperlink-_-EHL"></a>  }
                        <img className="footer__house" src={`${process.env.PUBLIC_URL}/assets/icons/icon_house.svg`} alt="House" /></span>
                    </div>
                    : ''
                    }
                </div>
                <p className="footer__copyright">
                    &copy; {getYear()} Bank of America Corporation. {t(footer.rights, { interpolation: { escapeValue: false } })}
                </p>

                {footer.ar &&
                    <p className="footer__ar">
                        {footer.ar}
                    </p>
                }
                {footer.map &&
                    <p className="footer__map">
                        {data.footerMap}
                    </p>
                }
            </div>
            {loadOneTrust()}
        </footer>
        </>
    );
};

export default Footer;